module.exports = __webpack_public_path__ + "media/application/images/svgs/settings-0e5ee494bdf11f85efa1193f85887e64.svg";